<template>
  <GlobalAlertWindow
    v-loading="isUploading"
    :title="title"
    :visible.sync="visible"
    :confirm-working="isWorking"
    @confirm="confirm"
  >
    <el-form :model="form" ref="form" :rules="rules" label-width="124px" label-suffix="：" >
      <el-form-item label="登录账号" prop="login">
        <el-input v-model="form.login" placeholder="请输入登录账号" v-trim/>
      </el-form-item>
      <el-form-item label="真实姓名" prop="realname">
        <el-input v-model="form.realname" placeholder="请输入真实姓名" v-trim/>
      </el-form-item>
      <el-form-item label="手机号" prop="phone">
        <el-input v-model="form.phone" placeholder="请输入手机号" v-trim/>
      </el-form-item>
      <el-form-item label="性别" prop="sex">
        <el-radio-group v-model="form.sex">
          <el-radio label="0">男</el-radio>
          <el-radio label="1">女</el-radio>
          <el-radio label="2">未知</el-radio>
        </el-radio-group>
        <!-- <el-input v-model="form.sex" placeholder="请输入性别 0男 1女 2未知" v-trim/> -->
      </el-form-item>
      <el-form-item label="地区" prop="areaId">
        <div class="address">
          <el-select v-model="form.province" placeholder="请选择省份" filterable @change="selectProvince">
            <el-option
              v-for="item in province"
              :key="item.id"
              :value="item.id"
              :label="item.name"
            ></el-option>
          </el-select>
          <el-select v-model="form.areaId" filterable placeholder="请选择城市">
            <el-option
              v-for="item in cities"
              :key="item.id"
              :value="item.id"
              :label="item.name"
            ></el-option>
          </el-select>
          <!-- <el-select v-model="form.areaId" filterable placeholder="请选择城市">
            <el-option
              v-for="item in areas"
              :key="item.id"
              :value="item.id"
              :label="item.name"
            ></el-option>
          </el-select> -->
        </div>
      </el-form-item>
      <el-form-item label="一句话介绍" prop="info">
        <el-input type="textarea" v-model="form.info" placeholder="请输入介绍(50字以内)" maxlength="50" v-trim/>
      </el-form-item>
      <!-- <el-form-item label="出生日期" prop="birthday">
        <el-date-picker v-model="form.birthday" value-format="yyyy-MM-dd" placeholder="请输入出生日期"></el-date-picker>
      </el-form-item> -->
      <el-form-item label="身份证号" prop="idcard">
        <el-input v-model="form.idcard" placeholder="请输入身份证号" v-trim/>
      </el-form-item>
      <el-form-item label="身份证正面照" prop="idcardImg">
        <!-- <el-input v-model="form.idcardImg" placeholder="请输入身份证正面照" v-trim/> -->
        <UploadAvatarImage
          :file="{ 'imgurlfull': form.idcardFullImg, 'imgurl': form.idcardImg }"
          :uploadData="uploadData"
          @uploadSuccess="uploadIdcardImgSuccess"
          @uploadEnd="isUploading = false"
          @uploadBegin="isUploading = true"
        />
      </el-form-item>
      <el-form-item label="身份证反面照" prop="idcardImgBack">
        <UploadAvatarImage
          :file="{ 'imgurlfull': form.idcardImgFullBack, 'imgurl': form.idcardImgBack }"
          :uploadData="uploadData"
          @uploadSuccess="uploadIdcardImgBackSuccess"
          @uploadEnd="isUploading = false"
          @uploadBegin="isUploading = true"
        />
      </el-form-item>
      <el-form-item label="关联系统用户" prop="memberId">
        <el-select
          v-model="form.memberId"
          placeholder="请输入会员昵称/手机号，再选择"
          filterable
          remote
          reserve-keyword
          :remote-method="remoteMethod"
          :loading="searchLoading"
        >
          <el-option
            v-for="item in users"
            :key="item.id"
            :label="item.nickname"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
  </GlobalAlertWindow>
</template>

<script>
import BaseOpera from '@/components/base/BaseOpera'
import GlobalAlertWindow from '@/components/common/GlobalAlertWindow'
import UploadAvatarImage from '@/components/common/UploadAvatarImage'
import { listByParentId } from '@/api/business/areas'
import { findAll } from '@/api/business/member'
import { checkMobile } from '@/utils/form'
export default {
  name: 'OperaCreationWindow',
  extends: BaseOpera,
  components: { GlobalAlertWindow, UploadAvatarImage },
  data () {
    let rules = (rules, value, callBack) => {
      // debugger
      if (!value) {
        callBack(new Error('请输入手机号'))
      } else {
        callBack()
      }
    }
    return {
      isUploading: false,
      searchLoading: false,
      uploadData: {
        folder: 'member'
      },
      // 表单数据
      form: {
        id: null,
        login: null,
        realname: '',
        phone: '',
        sex: '',
        province: '',
        city: '',
        areaId: '',
        idcard: '',
        idcardImg: '',
        idcardFullImg: '',
        idcardImgBack: '',
        idcardImgFullBack: '',
        nickname: '',
        memberId: ''
      },
      province: [],
      cities: [],
      areas: [],
      users: [],
      // 验证规则
      rules: {
        login: [
          { required: true, message: '请输入登录账号', tigger: 'blur' }
        ],
        phone: [
          { required: true, validator: checkMobile, tigger: 'blur' }
        ],
        memberId: [
          { required: true, validator: rules, message: '请选择关联用户', tigger: 'change' }
        ]
      }
    }
  },
  created () {
    this.config({
      api: '/business/creation',
      'field.id': 'id'
    })
    listByParentId({type: 0, parentId: ''})
      .then(data => {
        this.province = data
      })
  },
  methods: {
    open (title, target) {
      this.title = title
      this.visible = true
      this.cities = []
      this.areas
      if (target == null) {
        this.$nextTick(() => {
          this.$refs.form.resetFields()
          this.form[this.configData['field.id']] = null
        })
        return
      }
      // 编辑
      this.$nextTick(() => {
        for (const key in this.form) {
          this.form[key] = target[key]
        }
        debugger
        this.form.idcardFullImg = target.imgFullUrl + target.idcardImg
        this.form.idcardImgFullBack = target.imgFullUrl + target.idcardImgBack
        this.selectProvince(this.form.province, true)
        this.remoteMethod(this.nickname)
        console.log(this.form);
      })
    },
    selectProvince(val, isInit) {
      if (!isInit) {
        this.cities = []
        this.form.cityId = ''
        this.areas = []
        this.form.areaId = ''
      }
      listByParentId({ type: 1, parentId: val })
        .then(data => {
          this.cities = data
          if (isInit) {
            this.selectCity(this.form.cityId, isInit)
          }
        })
        .catch(e => {
          this.$tip.error(e)
        })
    },
    // 选择城市
    selectCity(val, isInit) {
      if (!isInit) {
        this.areas = []
        this.form.areaId = ''
      }
      listByParentId({ type: 2, parentId: val })
        .then(data => {
          this.areas = data
        })
        .catch(e => {
          this.$tip.error(e)
        })
      // const tempCity = this.cities.find(item => item.id === val)
      // if (tempCity) {
      //   this.areas = tempCity.childList
      // }
    },
    uploadIdcardImgSuccess(file) {
      this.form.idcardImg = file.imgurl
      this.form.idcardFullImg = file.imgurlfull
    },
    uploadIdcardImgBackSuccess(file) {
      this.form.idcardImgBack = file.imgurl
      this.form.idcardImgFullBack = file.imgurlfull
    },
    remoteMethod(query) {
      if (query !== '') {
        this.searchLoading = true
        findAll({
          model: {
            nickname: query,
            status: 0
          }
        })
          .then(res => {
            this.users = res
          })
          .catch(e => {
            this.$tip.error(e)
          })
          .finally(() => {
            this.searchLoading = false
          })
      }
    }
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/style/alertstyle.scss";
::v-deep .el-select {
  width: 100%;
  .el-input__inner {
    width: 100%;
  }
}
</style>
